import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CreateChannelFirst from "../Create_channel_screen/CreateChannelFirst";
import "./create.css";
import axios from "../../../../axios";

const Create = () => {
  const navigate = useNavigate();

  const [click, setClick] = useState(false);
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState(false);

  const teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));

  useEffect(() => {
    const getCommunity = async () => {
      setLoading(true);

      try {
        const res = await axios.get(
          `/api/v1/community/getByUserId/teacher/${teacher_id}`,
        );

        console.log("res.data.data", res.data.data);

        if (res.data.data?.length > 0) {
          const communityId = res.data.data[0].id;
          navigate("/TotalCommuPost", { state: { communityId } });
        } else {
          // No community found
          setStatus(true);
        }
      } catch (error) {
        console.error("Error fetching communities:", error);

        // API fail hone par bhi Create Channel UI dikhao
        setStatus(true);
      } finally {
        setLoading(false);
      }
    };

    if (teacher_id) {
      getCommunity();
    } else {
      setStatus(true);
      setLoading(false);
    }
  }, [teacher_id, navigate]);

  if (loading) {
    return <img className="Loader" src="/gif/LoaderDot.gif" alt="Loading..." />;
  }

  return (
    <>
      {status && (
        <div className="chanel_main_container">
          <div className="d-flex flex-column align-items-center">
            <span className="m-2 text-center create_description">
              No channels yet. Be the first one to create a channel for the
              community.
            </span>

            <button onClick={() => setClick(true)} id="addPreReadBtn">
              Create Channel
            </button>
          </div>
        </div>
      )}

      {click && <CreateChannelFirst change={setClick} />}
    </>
  );
};

export default Create;
